(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["decolab-editorial-guide"]) return;
  try {
    
  if(!customElements.get('dc-fit-checker'))customElements.define('dc-fit-checker',class extends HTMLElement{
    connectedCallback(){this.abort=new AbortController();this.addEventListener('input',()=>this.update(),{signal:this.abort.signal});this.update()}
    disconnectedCallback(){this.abort?.abort()}
    update(){const values=[...this.querySelectorAll('input')].map(i=>i.value.trim()===''?NaN:Number(i.value));const out=this.querySelector('output');if(!out)return;if(values.some(n=>!Number.isFinite(n)||n<=0)){out.textContent=this.dataset.empty;return}const[w,d,pw,pd]=values;const fits=pw<=w&&pd<=d;const fmt=n=>n.toLocaleString('pt-BR',{maximumFractionDigits:1});out.textContent=fits?`A base cabe nessas medidas. Sobra total: ${fmt(w-pw)} cm na largura e ${fmt(d-pd)} cm na profundidade. Confira também altura, acessórios e abertura de portas.`:`Nessa orientação, a peça ultrapassa o espaço informado. Confira outra posição ou uma medida menor antes de comprar.`}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({
            behavior: 'instant'
          });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
